import { useContext, useMemo } from 'react';

import { PlusOutlined, MinusOutlined } from '@ant-design/icons';

import {
  ColSize,
  ContentSection,
  Form,
  InputNumberForm,
  RowSize,
  SelectForm,
} from '../../../../../../../../../shared/components';
import {
  GenericDataFormContext,
  QUOTATION_BUTTON,
} from '../../../../../shared';

import { StepThreeFormContext } from '../../contexts/StepThreeForm';

import { ValidateForm } from '../../../../../../../../../shared/utils';

export const CivilPaymentMethods = () => {
  const validateForm = new ValidateForm();

  const { paymentMethods } = useContext(GenericDataFormContext);

  const {
    civilPaymentMethodsForm,
    commertialConditions,
    setLabelButton,
    clearPrimaFieldsOnFormChange,
    quotationResponse,
  } = useContext(StepThreeFormContext);

  const maxVariation = useMemo(
    () => commertialConditions?.puntosDeAumentoExtraPrimaVariable!,
    [commertialConditions]
  );
  const minVariation = useMemo(
    () => -commertialConditions?.puntosDeDisminucionExtraPrimaVariable!,
    [commertialConditions]
  );

  const prevValues = useMemo(
    () => ({
      prevEPVValue:
        quotationResponse?.condicionesComerciales.porRecargoAdminist,
      prevCommissionValue:
        quotationResponse?.condicionesComerciales.porComisionProd,
    }),
    [quotationResponse]
  );

  const onPaymentsMethodFormChange = (valueChanged: { variation: number }) => {
    setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
    clearPrimaFieldsOnFormChange();

    if (valueChanged?.variation?.toString().length) {
      const prevCommissionValue = Number(prevValues.prevCommissionValue);
      const prevEPVValue = Number(prevValues.prevEPVValue);

      if (prevCommissionValue !== undefined && prevEPVValue !== undefined) {
        civilPaymentMethodsForm.setFieldValue(
          'extraVariable',
          prevEPVValue + valueChanged.variation
        );
        civilPaymentMethodsForm.setFieldValue(
          'commission',
          prevCommissionValue + valueChanged.variation
        );
      }
    }
  };

  return (
    <Form
      formProps={{
        form: civilPaymentMethodsForm,
        name: 'civil-payment-methods-form',
        onValuesChange: onPaymentsMethodFormChange,
      }}
    >
      <ContentSection level='h3' title='Forma de pago y comisiones'>
        <RowSize>
          <ColSize size={20}>
            <SelectForm
              formProps={{
                label: 'Forma de pago:',
                name: 'paymentMethod',
              }}
              selectProps={{
                placeholder: 'Seleccionar',
                options: paymentMethods,
              }}
            />
          </ColSize>

          <ColSize size={20}>
            <InputNumberForm
              formProps={{
                label: 'Comisión:',
                name: 'commission',
              }}
              inputNumberProps={{
                readOnly: true,
                disabled: true,
                precision: 2,
              }}
            />
          </ColSize>

          <ColSize size={20}>
            <InputNumberForm
              formProps={{
                label: 'Extra prima variable:',
                name: 'extraVariable',
              }}
              inputNumberProps={{
                readOnly: true,
                disabled: true,
                precision: 2,
              }}
            />
          </ColSize>

          <ColSize size={20}>
            <InputNumberForm
              formProps={{
                label: 'Variación:',
                name: 'variation',
                rules: validateForm.generateRules({
                  label: 'variación',
                  rules: ['required', `range:${minVariation}:${maxVariation}`],
                }),
                initialValue: 0,
              }}
              inputNumberProps={{
                addonAfter: '%',
                controls: {
                  upIcon: <PlusOutlined />,
                  downIcon: <MinusOutlined />,
                },
                min: minVariation,
                max: maxVariation,
              }}
            />
          </ColSize>
        </RowSize>
      </ContentSection>
    </Form>
  );
};
